'use strict';

const tracking = require('dibs-tracking');

const heroList = 'main hero carousel';
const promoImpressions = [];

function getProductData(item, index, list) {

    const product = {
        url: item.url,
        name: item.title,
        position: index + 1,
        list
    };

    return product;
}

function getPromoCreative(element) {
    const anchor = element.querySelector('a');
    const url = anchor ? anchor.href : '';
    const creative = url.split('.com');

    return creative.length > 1 ? creative[1] : url;
}

function addPromoClick(element, promo) {
    const anchors = Array.from(element.querySelectorAll('a'));

    anchors.forEach(anchor => {
        anchor.addEventListener('click', () => {
            tracking.trackEcommerce({
                type: 'promoClick',
                promotions: [promo]
            });
        });
    });
}

function buildImpressions(items, callback) {
    if (items.length) {
        items.forEach((item, index) => {
            const position = index + 1;
            const promo = Object.assign({
                creative: getPromoCreative(item),
                position: position
            }, callback(item, position));

            addPromoClick(item, promo);
            promoImpressions.push(promo);
        });
    }
}

function getPersonalizationVariant(recommendable) {
    let variant = 'L3';

    // Nasty, but what can you do?
    if (recommendable.associatedCategory) {
        variant = 'attribute and L1';
    } else if (recommendable.trendingElement) {
        variant = 'trending';
    }

    return variant;
}

function getItems(selector) {
    return Array.from(document.querySelectorAll(selector));
}

function initPromoTracking() {
    const promoItems = getItems('.js-promo-item');
    const featuredItems = getItems('.js-featured-item');
    const editorialItems = getItems('.js-editorial-item');
    const shopByItems = getItems('.js-shop-by-pages-item');
    const locationsItems = getItems('.js-shop-by-locations-item');

    // Promos
    buildImpressions(promoItems, (item, position) => {
        return {
            id: `promo-tile-${position}`,
            name: `Promo Tile #${position}`
        };
    });

    // Featured
    buildImpressions(featuredItems, () => {
        return {
            id: 'five-brick-module',
            name: 'Five Brick Module'
        };
    });

    // Editorial
    buildImpressions(editorialItems, (item, position) => {
        return {
            id: `content-promo-${position}`,
            name: 'Content Promo'
        };
    });

    // Shop by products
    buildImpressions(shopByItems, item => {
        return {
            id: `shop-by-${item.getAttribute('data-ga-id')}`,
            name: `Shop by ${item.getAttribute('data-ga-name')}`
        };
    });

    // Dealer Locations
    if (locationsItems.length) {
        const promo = {
            id: 'shop-by-location',
            name: 'Shop by Location',
            creative: 'none',
            position: 1
        };

        locationsItems.forEach((locationsItem, index) => {
            const itemPromo = Object.assign({}, promo, {
                creative: getPromoCreative(locationsItem),
                position: index + 1
            });

            addPromoClick(locationsItem, itemPromo);
        });

        promoImpressions.push(promo);
    }

    // Fire impression tracking
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: promoImpressions
    });
}

module.exports = {

    init() {
        initPromoTracking();
    },

    trackHeroClick(item, itemIndex) {
        tracking.trackEcommerce({
            type: 'productClick',
            actionField: { list : heroList },
            products: [getProductData(item, itemIndex)]
        });
    },

    trackHeroImpression(visibleItems, startIndex) {
        tracking.trackEcommerce({
            type: 'productImpression',
            products: visibleItems.map((item, index) => getProductData(item, index + startIndex, 'main hero carousel'))
        });
    },

    trackCollectionsClick(item, itemIndex) {
        tracking.trackEcommerce({
            type: 'promoClick',
            promotions: [{
                id: 'featured-circles',
                name: 'Featured Circles',
                creative: `Featured Collections : ${item.title}`,
                position: itemIndex + 1
            }]
        });
    },

    trackCollectionsArrows(page, variant) {
        if (variant.isNext() || variant.isPrevious()) {
            tracking.trackEvent({
                action: 'featured circles',
                category: 'promo interaction',
                label: `${variant.variant} arrow clicked`
            });
        }
    },

    trackCollectionsImpression(visibleItems, itemStartIndex) {
        tracking.trackEcommerce({
            type: 'promotionImpression',
            promotions: visibleItems.map((item, index) => {
                return {
                    id: 'featured-circles',
                    name: 'Featured Circles',
                    creative: item.title,
                    position: index + itemStartIndex + 1
                };
            })
        });
    },

    // Personalization

    trackPersonalizationMount() {
        tracking.trackEcommerce({
            type: 'promotionImpression',
            promotions: [{
                id: 'personalized-items-categories-carousel',
                name: 'Personalized Items and Categories Carousel',
                creative: 'Personalized Items and Categories Carousel',
                position: 1
            }]
        });
    },

    trackPersonalizationPromoClick() {
        tracking.trackEcommerce({
            type: 'promoClick',
            promotions: [{
                id: 'personalized-items-categories-carousel',
                name: 'Personalized Items and Categories Carousel',
                creative: 'Personalized Items and Categories Carousel',
                position: 1
            }]
        });
    },

    trackPersonalizationImpression(visibleRecommendations, recommendationStartIndex) {
        // There can only be one visible recommendation at a time.
        const recommendation = visibleRecommendations[0];
        const visibleItems = recommendation.items;
        const startIndex = recommendationStartIndex * visibleItems.length;
        tracking.trackEcommerce({
            type: 'productImpression',
            products: visibleItems.map((item, index) => {
                return {
                    id: item.id,
                    name: item.title,
                    category: recommendation.url.slice(1, -1),
                    brand: item.seller.id,
                    variant: `homepage - ${getPersonalizationVariant(recommendation)}`,
                    position: index + startIndex + 1,
                    list: 'personalized-items-carousel'
                };
            })
        });
    },

    trackPersonalizationItemClick(item, {variant, category, position}) {
        tracking.trackEcommerce({
            type: 'productClick',
            actionField: {
                list: 'personalized-items-carousel'
            },
            products: [{
                id: item.pk,
                name: item.title,
                brand: item.seller.id,
                category: category.slice(1, -1),
                position: position + 1,
                variant: `homepage - ${variant}`
            }]
        });

        tracking.trackEvent({
            category: 'promo interaction',
            action: 'personalized items and categories carousel',
            label: `product clicked-${variant}`
        });
    },

    trackPersonalizationViewAll(variant) {
        tracking.trackEvent({
            category: 'promo interaction',
            action: 'personalized items and categories carousel',
            label: `view all clicked-${variant}`
        });
    },

    trackPersonalizationDotClick(variant) {
        tracking.trackEvent({
            category: 'promo interaction',
            action: 'personalized items and categories carousel',
            label: `paginate clicked-${variant}`
        });
    },

    getPersonalizationVariant
};



// WEBPACK FOOTER //
// ./assets/js/home/helpers/tracking.es.js